<template>
  <b-col md="12" style="padding: 0 30px" class="my-3">
    <b-row class="border rounded-md pt-2">
      <!-- Period -->
      <b-col md="2" v-if="filters?.dateRange.length">
        <b-form-group label="Period :">
          <div class="d-flex">
            <p class="mb-0 text-black" style="font-weight: 500">
              {{
                filters?.dateRange[0]
                  ? moment(filters?.dateRange[0]).format('DD MMM YYYY')
                  : ''
              }}
              -
              <span>
                {{
                  filters?.dateRange[1]
                    ? moment(filters?.dateRange[1]).format('DD MMM YYYY')
                    : ''
                }}
              </span>
            </p>
          </div>
        </b-form-group>
      </b-col>

      <!-- Fleet Category -->
      <b-col md="3" v-if="filters?.vehicleTypeIds.length">
        <b-form-group label="Fleet Category :">
          <template>
            <b-badge
              variant="success"
              v-for="(type, index) in filters?.vehicleTypeIds"
              :key="index"
              class="mr-1"
            >
              {{ type.name }}
            </b-badge>
          </template>
        </b-form-group>
      </b-col>

      <!-- Fleet Name -->
      <b-col md="3" v-if="filters?.vehicleIds.length">
        <b-form-group label="Fleet Name :">
          <template>
            <b-badge
              variant="warning"
              v-for="(type, index) in filters?.vehicleIds"
              :key="index"
              class="mr-1"
            >
              {{ type.name }}
            </b-badge>
          </template>
        </b-form-group>
      </b-col>

      <!-- Job Class -->
      <b-col
        md="2"
        v-if="
          filters.filterJobType === 'jobClass' && filters?.jobClassIds.length
        "
      >
        <b-form-group label="Job Class :">
          <b-badge
            variant="danger"
            v-for="(type, index) in filters?.jobClassIds"
            :key="index"
            class="mr-1"
          >
            {{ type.name }}
          </b-badge>
        </b-form-group>
      </b-col>

      <!-- Job Type -->
      <b-col
        md="2"
        v-if="filters.filterJobType === 'jobType' && filters?.jobTypeIds.length"
      >
        <b-form-group label="Job Type :">
          <b-badge
            variant="danger"
            v-for="(type, index) in filters?.jobTypeIds"
            :key="index"
            class="mr-1"
          >
            {{ type.name }}
          </b-badge>
        </b-form-group>
      </b-col>

      <!-- Status -->
      <b-col md="2">
        <b-form-group label="Status :">
          <p class="mb-0 text-black" style="font-weight: 500">
            {{ filters?.status ? statusText(filters?.status) : 'All' }}
          </p>
        </b-form-group>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import moment from 'moment'

export default {
  name: 'FilterMaintenancePreview',
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
}
</script>
